export default __webpack_public_path__ + "static/media/rectangles-no-7.9aa35d79.ogg";